<template>
    <div class="grain" :style="grainBackgroundStyle" />
    <div
        class="relative overflow-x-hidden selection:text-gray-400 selection:bg-light"
    >
        <VueLenis root ref="lenisRef">
            <div
                ref="nuxtStartupTransitionContainer"
                class="w-screen min-h-screen transition-opacity duration-75 bg-white"
            >
                <Navigation />
                <SocialMediaFixed />
                <div data-page>
                    <NuxtPage />
                </div>
                <Footer data-scroll-section />
            </div>
        </VueLenis>
        <!-- <Transition v-if="!config.dev" /> -->
    </div>
</template>

<script setup lang="ts">
import { VueLenis } from 'lenis/vue';

const head = useLocaleHead({
    addDirAttribute: true,
    identifierAttribute: 'id',
    addSeoAttributes: true,
});

const img = useImage();

const grainBackgroundStyle = computed(() => {
    const imgUrl = img('/images/grain/grain.gif', {
        format: 'gif',
        animated: true,
    });

    return { backgroundImage: `url('${imgUrl}')` };
});
</script>

<style>
* {
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    font-feature-settings: 'kern';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.no-ligature {
    -moz-font-feature-settings: 'liga' off;
    font-feature-settings: 'liga' off;
}
.underline-offset-3 {
    text-underline-offset: 3px;
}
.FADE_UP {
    opacity: 0;
}
.FADE_LEFT {
    opacity: 0;
}
.FADE_UP_IMAGE img {
    opacity: 0;
}

.grain {
    position: fixed;
    pointer-events: none;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background-position: 0 0;
    background-size: auto;
    background-repeat: repeat;
    background-attachment: fixed;
    opacity: 0.0275;
}
</style>
